<template>

<div>
  


<template>
  <CerrarSesionDialog ref="componenteHijo"></CerrarSesionDialog>
  <v-app-bar
      app
      dark
     
      >
    <!-- 
      prominent
    scroll-off-screen  -->
      <template v-slot:img="{ props }" >
        <v-img
          v-bind="props"
          gradient=""
          class="hidden-sm-and-down"
        ></v-img>
      </template>
        <v-toolbar-title>Menu Usuario</v-toolbar-title>
        <v-spacer></v-spacer>
<template >
      <v-btn icon >
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn icon class="hidden-sm-and-down">
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <AvatarUsuario />
</template>
        <template v-slot:extension>
        <v-tabs
          align-with-title
          background-color="transparent"
        >

      <v-tab class="mr-3 google-font hidden-sm-and-down"
        style="text-transform: capitalize;pading" 
        @click="perfilEdit()"
        >
        LINKS TEC
        </v-tab>


<!-- style="text-transform: capitalize ;pading"  -->
        <v-tab
        v-for="(link, i) in linksUsuario"
        :key="i"
        :to="link.to"
        class="mr-3 google-font hidden-sm-and-down"
        
        @click="onClick($event, link)"
        data-cy="menu"
      >
        {{ link.text }}
        </v-tab>
       
        

        
 <!-- style="text-transform: capitalize;pading"  -->
        <v-tab class="mr-3 google-font hidden-sm-and-down"
       
        @click="openCerrarSesionDialog()"
        
        >
        Cerrar Sesión
        </v-tab>



        </v-tabs>
      </template>
 <v-app-bar-nav-icon class="hidden-md-and-up"
      @click="toggleDrawer"></v-app-bar-nav-icon>
</v-app-bar>



</template>

</div>
  





</template>


<script>


import CoreView from '@/components/common/View'
import ChapterDetails from '@/assets/data/chapterDetails.json'

import router from "@/router/index";


import loginService from "@/services/loginService.js";


import CerrarSesionDialog from "@/components/usuario/CerrarSesionDialog.vue"

import AvatarUsuario from "@/components/common/navegacion/AvatarUsuario.vue"


  import { 
    mapGetters,
    mapMutations
  } from 'vuex'
  export default {
    name:'Menu',
   data() {
      return {
        ChapterDetails:ChapterDetails,
        
      }
    },
    components:{

        CoreView,
        CerrarSesionDialog,
        AvatarUsuario,

    },
    computed: {
      ...mapGetters(['linksUsuario'])
    },
    methods: {
      ...mapMutations(['toggleDrawer']),
      onClick (e, item) {
        e.stopPropagation()
        if (item.to || !item.href) return
        this.$vuetify.goTo(item.href)
      },
  perfilEdit(){

    var identificador = localStorage.getItem('identificador');


if (identificador) {
      // Navegar a la ruta con el identificador como parámetro
      this.$router.push(`/perfil/${identificador}/add/`);
    } else {
      console.error('No se encontró ningún identificador en el Local Storage.');
    }

  },

  openCerrarSesionDialog() {
    this.$refs.componenteHijo.openDialog(); // Llama al método en el componente hijo
    },


    }
  } 
</script>

